<template>
  <div class="sort_icon">
    <SjIcon :size="20" :iconSize="14" :imgSrc="imgSrc" :stopEvent="false" />
    <span class="order_number" v-if="priority">
      {{ priority }}
    </span>
  </div>
</template>

<script>
/**
 * sort-icon，用于表格表头排序图标
 */
export default {
  props: {
    order: {
      type: String
    },
    priority: {
      type: Number
    }
  },
  computed: {
    imgSrc() {
      if (this.order === "ascending") {
        return require("./sort_up.svg");
      } else {
        if (this.order === "descending") {
          return require("./sort_down.svg");
        } else {
          return require("./sort.svg");
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.sort_icon {
  width: 20px;
  height: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .order_number {
    position: absolute;
    left: 0;
    bottom: 0;
    .text("caption", "highlight", "semibold");
    transform: scale(9/12);
    transform-origin: left bottom;
  }
}
</style>
